import Tooltip from "components/Tooltip/Tooltip";
import { getLocalTimezoneDate } from "config/ts-utils";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ReactTimeAgo from "timeago-react";

interface TimeAgoProps {
    className?: string;
    datetime: string;
    hideTooltip?: boolean;
}

export const TimeAgo = ({ className, datetime, hideTooltip }: TimeAgoProps) => {
    const localTimezoneDate = getLocalTimezoneDate(datetime);

    return hideTooltip ? (
        <ReactTimeAgo className={className} datetime={datetime} />
    ) : (
        <Tooltip
            overlay={localTimezoneDate}
            overlayStyle={{ zIndex: 3000 }}
            overlayClassName="light overlapText"
            triggerClassName="overlapTextTrigger"
            placement="bottomLeft"
            align={{ points: ["cc", "cc"], offset: [0, 0] }}
        >
            <ReactTimeAgo className={className} datetime={datetime} />
        </Tooltip>
    );
};

export const TimeLeft = ({ datetime, hideTooltip }: TimeAgoProps) => {
    const localTimezoneDate = getLocalTimezoneDate(datetime);
    dayjs.extend(relativeTime);
    const time = dayjs(datetime).endOf("hour").fromNow();

    return hideTooltip ? (
        <span>{time}</span>
    ) : (
        <Tooltip
            overlay={localTimezoneDate}
            overlayStyle={{ zIndex: 3000 }}
            overlayClassName="light overlapText"
            triggerClassName="overlapTextTrigger"
            placement="bottomLeft"
            align={{ points: ["cc", "cc"], offset: [0, 0] }}
        >
            {time}
        </Tooltip>
    );
};
